import React, {PropsWithChildren} from "react";
import { useAppDispatch, store, useAppSelector } from "../../services/store";
import { getCurrentChild, logout } from "src/shared/redux-state/src";
import { ChildrenStoreData } from "src/shared/types/src";
import { AppRoutes } from "src/app/navigation/routes";
import {NavLink} from "react-router-dom";
import { Nav, NavItem } from 'reactstrap';
import ProfileLayout from "src/app/layouts/ProfileLayout";

const ProfileBaseScreen: React.FC<PropsWithChildren> = ({children}) => {

    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    return (
        <ProfileLayout title={"Child Profile"}>
            <div className="custom-tab custom-tab-two">
                <Nav>
                    {
                        currentChild?.systemsEnabled?.eymanage && currentChild?.systemAccess?.eymanage ? 
                            <>
                                <NavItem>
                                    <NavLink to={AppRoutes.BASIC_PROFILE} className={({ isActive }) => (isActive ? 'active text-decoration-none d-block fs-12 fw-bold text-primary' : 'text-gray-300 text-decoration-none d-block fs-12 fw-regular')}>
                                        Details
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink to={AppRoutes.PARENTAL_PROFILE} className={({ isActive }) => (isActive ? 'active text-decoration-none d-block fs-12 fw-bold text-primary' : 'text-gray-300 text-decoration-none d-block fs-12 fw-regular')}>
                                        Parental Details
                                    </NavLink>
                                </NavItem>
                            </> : null
                    }
                </Nav>
            </div>
            {children}
        </ProfileLayout>
    )
}

export default ProfileBaseScreen;